<template>
  <ValidationObserver ref="observer">
    <form class="changepwd-form" @submit.prevent="submit">
      <div class="d-flex flex-column flex-md-row align-md-center">
        <div class="flex-1">
          <div class="text-5">Current password</div>
          <ValidationProvider
            v-slot="{ errors }"
            name="Current password"
            rules="required"
          >
            <v-text-field
              v-model="currentPassword"
              :error-messages="errors"
              placeholder="Verify current password"
              :append-icon="showCurrentPwd ? 'far fa-eye' : 'far fa-eye-slash'"
              :type="showCurrentPwd ? 'text' : 'password'"
              @click:append="showCurrentPwd = !showCurrentPwd"
              outlined
              class="c-input mt-2"
              required
              tabindex="1"
            ></v-text-field>
          </ValidationProvider>
        </div>
        <div class="flex-1 ml-md-4">
          <div class="text-5">New password</div>
          <ValidationProvider
            v-slot="{ errors }"
            name="New password"
            rules="required|min:8|max:64"
            vid="confirmation"
          >
            <v-text-field
              v-model="password"
              :error-messages="errors"
              placeholder="Enter new password"
              :append-icon="showPwd ? 'far fa-eye' : 'far fa-eye-slash'"
              :type="showPwd ? 'text' : 'password'"
              @click:append="showPwd = !showPwd"
              outlined
              class="c-input mt-2"
              required
              tabindex="2"
            ></v-text-field>
          </ValidationProvider>
        </div>
        <div class="flex-1 ml-md-4">
          <div class="text-5">Confirm password</div>
          <ValidationProvider
            v-slot="{ errors }"
            name="Confirm new password"
            rules="required|min:8|max:64|confirmed:confirmation"
          >
            <v-text-field
              v-model="confirmPassword"
              :error-messages="errors"
              placeholder="Re-enter new password"
              :append-icon="showCfgPwd ? 'far fa-eye' : 'far fa-eye-slash'"
              :type="showCfgPwd ? 'text' : 'password'"
              @click:append="showCfgPwd = !showCfgPwd"
              class="c-input mt-2"
              outlined
              required
              tabindex="3"
            ></v-text-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="mt-3 d-flex justify-end">
        <input type="submit" class="d-none" />
        <c-btn
          :loading="changePassword.isSubmitting"
          tabindex="4"
          :disabled="!currentPassword || !password || !confirmPassword"
          @click="submit"
          >Change Password</c-btn
        >
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";
import { required, min, max, confirmed } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});

extend("min", {
  ...min,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("max", {
  ...max,
  message: "Please enter 8 to 64 alphanumeric characters or symbols.",
});

extend("confirmed", {
  ...confirmed,
  message: "Passwords don't match.",
});

export default {
  name: "ChangePasswordForm",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    showPwd: false,
    showCfgPwd: false,
    showCurrentPwd: false,
    currentPassword: "",
    password: "",
    confirmPassword: "",
  }),
  computed: mapGetters({
    changePassword: "userInfo/changePassword",
  }),
  methods: {
    async submit() {
      const isFormValid = await this.$refs.observer.validate();
      if (isFormValid) {
        await this.$store.dispatch("userInfo/changePassword", {
          currentPassword: this.currentPassword,
          newPassword: this.password,
        });
        if (!this.changePassword.error) {
          this.$store.dispatch("addAlert", {
            title: "Success",
            type: "success",
            message: "Password changed",
          });
        } else {
          this.$store.dispatch("addAlert", {
            message: this.changePassword.error.message,
            type: "error",
            title: "Error",
          });
        }
      }
    },
  },
};
</script>
